(function ($) {
	const productsTeaser = $(".indy-block-products-teaser");

	if (productsTeaser.length > 0) {

		productsTeaser.each((index, item) => {
			const teaser = $(item);
			let slider = teaser.find(".indy-block-products-teaser-inner");
			initSlider(slider, teaser.find('.indy-block-products-teaser-btn.left'), teaser.find('.indy-block-products-teaser-btn.right'));
		});
	}

	function initSlider(slider, prevArrow, nextArrow) {
		slider.slick({
			mobileFirst: true,
			infinite: false,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			slidesToShow: 1,
			prevArrow: prevArrow,
			nextArrow: nextArrow,
			centerMode: false,
			swipeToSlide: true,
			speed: 200,
			responsive: [
				{
					breakpoint: 1, // 1px-576px wide screen for smaller centerPadding
					settings: {
						centerPadding: '4rem',
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 576,
					settings: {
						centerPadding: '6rem',
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1400,
					settings: {
						centerMode: false,
						slidesToShow: 5,
					}
				},
			]
		});
	}
})(jQuery);
